import React from 'react';
import { Section } from './ui/Section';
import { Card } from './ui/Card';
import { Button } from './ui/Button';
import { Check, Calendar, Users, Video } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    title: 'Program 1 la 1',
    subtitle: 'Psihoterapie & Coaching (Metoda 3S)',
    icon: <Users className="w-6 h-6" data-id="element-176" />,
    features: ['Reducem anxietatea și fricile care te controlează', 'Reglăm corpul și sistemul tău emoțional', 'Lucrăm tiparele relaționale', 'Clarificăm direcția și deciziile', 'Reconstruim încrederea în sine'],
    cta: 'Aplică pentru Programul 1 la 1',
    variant: 'primary' as const
  }, {
    title: 'Ateliere online LIVE',
    subtitle: 'Lucru practic pe teme',
    icon: <Video className="w-6 h-6" data-id="element-177" />,
    features: ['Anxietate & atacuri de panică', 'Frici și blocaje în decizii', 'Dependențe emoționale / relații toxice', 'Comunicare și limite', 'Reconectare corp–suflet–Dumnezeu'],
    cta: 'Vezi Calendarul Atelierelor',
    variant: 'secondary' as const
  }, {
    title: 'Cursuri online',
    subtitle: 'Înregistrate (self-paced)',
    icon: <Calendar className="w-6 h-6" data-id="element-178" />,
    features: ['Structură + disciplină mentală', 'Tehnici practice pentru reglare emoțională', 'Instrumente pentru relații și comunicare', 'Reconectare interioară consecventă', 'Acces pe viață la materiale'],
    cta: 'Vezi Cursurile Disponibile',
    variant: 'outline' as const
  }];
  return <Section id="servicii" background="default" data-id="element-179">
      <div className="text-center mb-16" data-id="element-180">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-text mb-4" data-id="element-181">
          Modalități de a lucra cu mine
        </h2>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-182">
          Alege formatul care ți se potrivește cel mai bine pentru călătoria ta.
        </p>
      </div>

      <div className="grid lg:grid-cols-3 gap-8" data-id="element-183">
        {services.map((service, index) => <Card key={index} className="flex flex-col h-full hover:shadow-xl transition-all duration-300 border-t-4 border-t-brand-primary" data-id="element-184">
            <div className="mb-6" data-id="element-185">
              <div className="w-12 h-12 rounded-lg bg-brand-bg flex items-center justify-center text-brand-primary mb-4" data-id="element-186">
                {service.icon}
              </div>
              <h3 className="text-2xl font-bold text-brand-text mb-2" data-id="element-187">
                {service.title}
              </h3>
              <p className="text-brand-primary font-medium" data-id="element-188">
                {service.subtitle}
              </p>
            </div>

            <ul className="space-y-4 mb-8 flex-1" data-id="element-189">
              {service.features.map((feature, i) => <li key={i} className="flex items-start text-gray-600 text-sm" data-id="element-190">
                  <Check className="w-5 h-5 text-brand-accent mr-3 flex-shrink-0" data-id="element-191" />
                  <span data-id="element-192">{feature}</span>
                </li>)}
            </ul>

            <Button variant={index === 0 ? 'primary' : 'outline'} fullWidth className="mt-auto" data-id="element-193">
              {service.cta}
            </Button>
          </Card>)}
      </div>
    </Section>;
}